import { NgModule } from '@angular/core';
import { AppMaterialModule } from '../app-material-module/app-material.module';
import { CommonModule } from '@angular/common';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { AppShareMapRoutingModule } from './app-share-map-routing.module';
import { ShareMapComponent } from './share-map/share-map.component';
import { CommonModuleModule } from '../common-module/common-module.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { SharedAdminLayerComponent } from './shared-admin-layer/shared-admin-layer.component';
import { AdminLayerDownloadComponent } from './admin-layer-download/admin-layer-download.component';
import { ProtectedModalComponent } from './protected-modal/protected-modal.component';
import { BusinessUserDashboardComponent } from './business-user-dashboard/business-user-dashboard.component';
import { MapPreviewComponent } from './map-preview/map-preview.component';
import { ColorPickerModule } from 'ngx-color-picker';
import { ShareLinkAndEmbedModalComponent } from './share-link-and-embed-modal/share-link-and-embed-modal.component';
import { MapCommonModule } from '../map-common/map-common.module';
import { AssignUserModule } from '../assign-user/assign-user.module';
import { MapProductModule } from '../map-product/map-product.module';
import {MatMenuModule} from '@angular/material/menu';
import { LassoToolsComponent } from 'projects/lib-map-common/src/lib/lasso-tool/lasso-tools.component';
import { ChartTableComponent } from 'projects/library-common-module/src/lib/chart-table/chart-table.component';
import { MapToolsComponent } from 'projects/lib-map-common/src/lib/map-tools/map-tools.component';
import { AnalysisPrintMapComponent } from 'projects/lib-map-common/src/lib/analysis-print-map/analysis-print-map.component';
import { CommonDragCodeComponent } from 'projects/lib-map-common/src/lib/common-drag-code/common-drag-code.component';
import { ShowLegendsComponent } from 'projects/lib-map-common/src/lib/show-legends/show-legends.component';
// import { ProximitryAnalysisModule } from '../proximitry-analysis/proximitry-analysis.module';
import { ToolsOperationComponent } from 'projects/lib-map-common/src/lib/tools-operation/tools-operation.component';
import { ProximityAnalysisComponent } from "../proximitry-analysis/proximity-analysis/proximity-analysis.component";


@NgModule({
    declarations: [ShareMapComponent, SharedAdminLayerComponent, AdminLayerDownloadComponent, ProtectedModalComponent, BusinessUserDashboardComponent, MapPreviewComponent, ShareLinkAndEmbedModalComponent],
    imports: [
    CommonModule,
    AppShareMapRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatAutocompleteModule,
    CommonModuleModule,
    AppMaterialModule,
    FlexLayoutModule,
    ColorPickerModule,
    MapCommonModule,
    AssignUserModule,
    MapProductModule,
    MatMenuModule,
    LassoToolsComponent,
    ChartTableComponent,
    MapToolsComponent,
    AnalysisPrintMapComponent,
    CommonDragCodeComponent,
    ShowLegendsComponent,
    // ProximitryAnalysisModule,
    ToolsOperationComponent,
    ProximityAnalysisComponent
],
    exports: [ShareMapComponent]
})
export class AppShareMapModule { }
